// De textuur-afwijkingen van het actieve bedrijf, voor elke boorprofiel-tekening in de backoffice.
//
// Bewust zonder api-import: boorprofiel-data.js leest hier en wordt ook door de node-tests van de
// backend geladen. app-main haalt de afwijkingen één keer op (een bedrijfswissel herlaadt de
// pagina) en de Texturen-pagina zet ze na het opslaan. Tekeningen die al op het scherm staan
// luisteren naar TEXTURES_EVENT om opnieuw te tekenen.

export const TEXTURES_EVENT = 'company-textures-updated';

let current = {};

/** Afwijkingen per catalogussleutel (zie @mv/models textures.ts); leeg = alles volgens de norm. */
export function getCompanyTextures() {
  return current;
}

export function setCompanyTextures(overrides) {
  current = overrides && typeof overrides === 'object' ? overrides : {};
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(TEXTURES_EVENT));
}
